import SearchInput from "@acko-tech/building-blocks.ui.search-input";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { $fontSize } from "@acko-tech/building-blocks.ui.common";

import { Text } from "@acko-tech/building-blocks.ui.typography";

import {
  BORDER_COLORS,
  TEXT_COLOR,
  ERROR_ACCENT
} from "@utils/bike/bikeConstants";

export const Wrapper = styled.div`
  position: relative;
`;

export const InputWrapper = styled(Wrapper)``;

const Label = `
top: -10px;
      left: 5px;
      font-size: 12px;
      color: #5e27c9;
`;

export const StyledSearchInput = styled(SearchInput)<{ focused: boolean }>`
  position: relative;

  &::after {
    content: "Search bike model";
    font-weight: 500;
    font-size: 12px;
    padding: 4px 8px;
    background: #fff;
    color: #414a53;
    position: absolute;
    top: 17px;
    left: 10px;
    font-size: 16px;
    margin: auto;
    transition: 0.2s ease;
    pointer-events: none;
    ${props => (props.focused ? Label : null)};
  }

  &:focus-within,
  & > input:valid {
    &::after {
      ${Label};
    }
  }

  & input {
    border: 1px solid ${BORDER_COLORS.NORMAL};
    background-color: transparent;
    font-size: ${$fontSize.xs};
    color: ${TEXT_COLOR.LIGHT};
    padding: 8px 50px 8px 12px;
    height: 60px;

    &:focus {
      border-color: #5e27c9;
    }
  }

  & > span {
    display: none;
  }
`;

export const ErrLabel = styled.span`
  font-size: 12px;
  color: ${ERROR_ACCENT};
  margin: 8px 8px 8px 0px;
`;

export const SearchButtonIcon = styled.img<{ variant?: string }>`
  width: 40px;
  height: auto;
  position: absolute;
  top: 10px;
  right: 10px;
  margin: auto;
`;

export const ListItem = styled.div`
  padding: 16px 0;
  font-size: ${$fontSize.xs};
  color: rgba(4, 2, 34, 1);
  border-bottom: 1px solid ${BORDER_COLORS.LIGHT};
  cursor: pointer;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const PopularHeading = styled(Text)`
  font-weight: 600;
  color: #5c5d66;
  font-size: ${$fontSize.xs};
  margin: 8px 0 8px 0;
`;

export const VehicleContainer = styled.div`
  max-height: 70vh;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;
